module.exports = __webpack_public_path__ + "static/media/undo.371b2bfe.svg";